import { AuthView } from '../../hooks/useAuthForm';

interface AuthNavigationProps {
  view: AuthView;
  onViewChange: (view: AuthView) => void;
}

export default function AuthNavigation({ view, onViewChange }: AuthNavigationProps) {
  return (
    <div className="mt-6 space-y-3 text-center">
      {view === 'sign_up' && (
        <>
          <button
            type="button"
            onClick={() => onViewChange('sign_in')}
            className="block w-full text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary hover:text-[#E34290] transition-colors"
          >
            Already have an account? <span className="font-medium text-[#E34290]">Sign in</span>
          </button>
        </>
      )}

      {view === 'sign_in' && (
        <>
          <button
            type="button"
            onClick={() => onViewChange('forgotten_password')}
            className="block w-full text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary hover:text-[#E34290] transition-colors"
          >
            Forgot your password?
          </button>
          <button
            type="button"
            onClick={() => onViewChange('sign_up')}
            className="block w-full text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary hover:text-[#E34290] transition-colors"
            data-ph-capture-attribute="btn-login-sign-up"
          >
            New to Jua? <span className="font-medium text-[#E34290]">Get started</span>
          </button>
        </>
      )}

      {(view === 'forgotten_password' || view === 'update_password') && (
        <button
          type="button"
          onClick={() => onViewChange('sign_in')}
          className="block w-full text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary hover:text-[#E34290] transition-colors"
        >
          Remember your password? <span className="font-medium text-[#E34290]">Sign in</span>
        </button>
      )}
    </div>
  );
}
